import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path:'/map',
            name:'Map',
            meta: {
                keepAlive: true
            },

            component: () => import(/* map */ './views/map/Map.vue'),

            // children:[       //抛弃子路由，太依赖与网络，切换效果不好做,更不好控制回退等等
            //
            //     {
            //       path:'selectePOI/:type/:poiID',         //选中poi
            //       name:'selectePOI',
            //       meta: {
            //           keepAlive: true
            //       },
            //     },
            //
            //     {
            //         path:'poiDetail/:type/:poiID',      //显示详情
            //         name:'poidetail',
            //         meta: {
            //             keepAlive: true
            //         },
            //
            //         component:()=>import(/*poi详情*/ './views/map/modules/routes/poiDetailGather/PoiDetailGather.vue')
            //     },
            //
            //     /*占位路由*/
            //     {
            //         path:'route',
            //         name:'route',
            //         meta: {
            //             keepAlive: true
            //         },
            //         component:()=>import(/*获取路径规划*/ './views/map/Route-null.vue')
            //     }
            // ]
        },
        {
            path:'/search',
            name:'Search',
            meta: {
                keepAlive: true
            },
            component: () => import(/* search */ './views/search/Search.vue')
        },

        {
            path:'/qqmap',
            name:'QQMap',
            meta: {
                keepAlive: true
            },
            component: () => import(/* search */ './views/qqMap/map/Map.vue')
        },

        {
            path:'/qqSearch',
            name:'QQSearch',
            meta: {
                keepAlive: true
            },
            component: () => import(/* search */ './views/qqMap/search/Search.vue')
        },

        {
            path:'/qqRoute',
            name:'QQRoute',
            meta: {
                keepAlive: true
            },
            component: () => import(/* search */ './views/qqMap/route/Route.vue')
        },

        {
            path:'/parking',
            name:'Parking',
            meta: {
                keepAlive: true
            },
            component: () => import(/* search */ './views/parking/Parking.vue')
        },

        {
            path:'/classify',
            name:'Classify',
            meta: {
                keepAlive: true
            },
            component: () => import(/* search */ './views/classify/Classify.vue')
        },

        {
            path:'/arTip',
            name:'ArTip',
            meta: {
                keepAlive: true
            },
            component:()=>import('./views/tips/AR_Tips.vue')
        },

        {
            path:'/activity',
            name:'Activity',
            meta: {
                keepAlive: true
            },
            component: () => import(/* activity */ './views/activity/modules/list/List.vue'),

        },
        {
            path:'/details/:type/:id',
            name:'Details',
            meta: {
                keepAlive: true
            },
            component: () => import('./views/activity/modules/details/Details.vue')

        },
        {
            path:'/storelist',
            name:'Storelist',
            meta: {
                keepAlive: true
            },
            component: () => import('./views/activity/modules/storelist/Storelist.vue')

        },
        {
            path:'/searchcar',
            name:'SearchCar',
            meta: {
                keepAlive: true
            },
            component: () => import('./views/car/SearchCar.vue')

        },
        {
            path:'/findCar',
            name:'FindCar',
            meta: {
                keepAlive: true
            },
            component:()=>import('./views/findCar/FindCar.vue')
        },
        {
            path:'/error',
            name:'Error',
            meta: {
                keepAlive: true
            },
            component: () => import('./views/error/Error.vue')
        },


    ]
})


